/**
 * Methods for API for different operations with publishing
 * @type {Object}
 */
export const API_METHODS = {
  add: 'post',
  edit: 'put',
  remove: 'delete',
};
